<template>
  <div v-if="section && section.blocks">
    <!-- Header -->
    <div class="reviewers__header">
      <h1 class="alternative-page">
        <i class="signature">Our</i>
        <span class="outline" style="--text:'Reviewers'">Reviewers</span>
      </h1>
    </div>

    <!-- Reviewer Blocks -->
    <div class="reviewers__blocks--wrapper">
      <header class="reviewers__blocks-header">
        <p>Please, click on the cards to learn more.</p>
      </header>
      <div class="reviewers__blocks">
        <div
          class="reviewers-block"
          :class="{ 'active': idx == activeReviewer }"
          v-for="(reviewer, idx) in reviewers"
          @click="open(idx)"
          :key="reviewer.id">
          <h5 class="reviewers-block__label">{{ reviewer.name }}</h5>
        </div>
      </div>
    </div>

    <!-- Person Modal -->
    <modal
      name="reviewer"
      width="90%"
      height="85%"
      :maxWidth="850"
      :maxHeight="500"
      :adaptive="true"
      @before-close="activeReviewer = null">
      <div class="modal-person" v-if="reviewers[activeReviewer]">
        <button
          class="vm--close"
          @click="close()">
        </button>
        <div class="modal-person__left">
          <i class="signature">Please meet</i>
          <h1>{{ reviewers[activeReviewer].name }}</h1>
          <div v-html="reviewers[activeReviewer].content"></div>
        </div>
        <div class="modal-person__right" v-if="reviewers[activeReviewer].image.src">
          <VImg :media="reviewers[activeReviewer].image" />
          <p v-if="reviewers[activeReviewer].fb_link">
            <small>
              <a
                class="btn--small"
                :href="reviewers[activeReviewer].fb_link"
                target="_blank"
                :title="`${ reviewers[activeReviewer].name }'s facebook link`"
                :aria-label="`${ reviewers[activeReviewer].name }'s facebook link`">
                {{ reviewers[activeReviewer].name }}'s facebook link
              </a>
            </small>
          </p>
        </div>
      </div>
    </modal>
  </div>
  <Loading
    v-else
    :activated="true"
  />
</template>

<script>
import VImg from './../components/VImg'
import Loading from './../components/Loading'

export default {
  name: 'Reviewers',

  components: { VImg, Loading },

  props: [ 'page_content' ],

  computed: {
    reviewers () {
      return this.section.blocks
    }
  },
  
  data () {
    return {
      section: null,
      activeReviewer: null
    }
  },

  mounted () {
    this.loadSection()
  },

  methods: {
    loadSection () {
      fetch(`/collections/all?view=reviewers`)
        .then(res => res.json()).then(data => {
          if (data.length) {
            this.section = JSON.parse(data)
          }
        })
    },
    open (idx) {
      this.activeReviewer = idx
      this.$modal.show('reviewer')
    },
    close () {
      this.$modal.hide('reviewer')
    }
  }
}
</script>
